import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LibraryApiService } from './library-api.service';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {

  constructor(
    private _translate: TranslateService,
    private apiService: LibraryApiService) { }

      /**
     * This is the pollPaymentAuthCodeStatus function
     * @param deviceId string
     * @returns Observable<any>
    */
   pollPaymentAuthCodeStatus(deviceId: string, appRef?:string, cardId?:string): Observable<any> {
    return this.apiService.pollPaymentAuthCodeStatus(deviceId,appRef, cardId).pipe(
        map(res => {
            return res;
        })
    );
}

  /**
   * This is the getCodeText function
   * @param code string
   * @returns string
   */
  getCodeText(code: string, params: any = null): string {
    return this._translate.instant(code, params);
  }
}
